import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCar8Ev: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-8-ev, mini-van"><path d="M4.25 17.25H1.75V4.75H16.5L22.25 9.75V17.25H19.75" stroke="currentColor" strokeWidth="1.5"/><path d="M9.75 17.25H14.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="7" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M14.5 10H11.9167L12.3334 7L8.5 12H11.0833L10.6667 15L14.5 10Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCar8Ev;
